import Joi from 'joi';
import imageWithMetaDataSchema from '@utils/validate/blocksSchemes/imageWithMetadataSchema';
import imagesWithBlurSchema from '@utils/validate/blocksSchemes/imagesWithBlurSchema';
const mosaicBlockSchema = Joi.object({
  type: Joi.string().valid('mosaicBlock').required(),
  code: Joi.string().allow('', null).required(),
  reverse: Joi.bool().required(),
  backgroundColor: Joi.string().allow('', null).required(),
  image: Joi.alternatives().try(Joi.string(), Joi.object(imageWithMetaDataSchema).unknown(true)).allow(null, ''),
  thumbnail: Joi.alternatives().try(imageWithMetaDataSchema, Joi.string()).allow('', null),
  video: Joi.string().allow('', null).required(),
  title: Joi.string().allow('', null).required(),
  subTitle: Joi.string().allow('', null).required(),
  description: Joi.string().allow('', null).required(),
  textColor: Joi.string().allow('', null).required(),
  buttonLink: Joi.object({
    anchor: Joi.string().allow('', null),
    parameters: Joi.string().allow('', null),
    target: Joi.string().allow('', null),
    text: Joi.string().allow('', null),
    url: Joi.string().allow('', null).required()
  }).unknown(true),
  buttonText: Joi.string().allow('', null).required(),
  buttonStyle: Joi.string().allow('', null).required(),
  imagesWithBlur: imagesWithBlurSchema,
  thumbnailsWithBlur: imagesWithBlurSchema,
  variant: Joi.string().optional()
}).unknown(true);
export default mosaicBlockSchema;